/** Camadas de z-index — tour acima do modal ao guiar campos dentro de diálogos. */
export const Z_INDEX_TOUR_OVERLAY = 9990;
export const Z_INDEX_TOUR_TOOLTIP = 9995;
export const Z_INDEX_MODAL = 10000;
export const Z_INDEX_TOUR_OVERLAY_MODAL = 10001;
export const Z_INDEX_TOUR_TOOLTIP_MODAL = 10002;

export const ONBOARDING_MODAL_SELECTOR = '[data-onboarding-modal]';
